export default String.raw`
<div class="offline-container">
    <div class="logo">
        <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}">
            <img src="{{config.Shop.ImageUrl}}" alt="{{ config.Shop.Name }}" loading="eager" fetchpriority="high">
        </a>
    </div>
    <div class="content">
        <img src="css/img/offline.jpg" alt="Offline" width="460" height="428" loading="eager" fetchpriority="high">
        <div class="bold-text">{{translations.OneTwoThree | Upcase}}</div>
        <div class="light-text">{{translations.OfflineInfo}}</div>
    </div>
</div>
`